import styled from 'styled-components';
import { useImpactChartContext, useImpactChartFontSizes, useImpactChartWidths } from '../context';
import { grayBorder } from '../shared';
import { BackLine } from './common/backline';
import { ModelReleaseText } from './common/model-version-text';
import { NetScores } from './common/net-scores';

export function BottomMobile() {
  const { hideNetScore, version, hideReleaseText } = useImpactChartContext();
  const showNetScore = !hideNetScore;

  const widths = useImpactChartWidths();
  const fontSizes = useImpactChartFontSizes();
  const spacing = fontSizes.netScore * 0.65;
  return (
    <Root>
      <Scores>
        {showNetScore && <BackLine />}
        {showNetScore && <NetScores />}
      </Scores>
      <VersionAndSuggestFixes style={{ marginTop: spacing, paddingLeft: widths.titleTextPadding }}>
        {!hideReleaseText && <ModelReleaseText version={version} />}
      </VersionAndSuggestFixes>
    </Root>
  );
}

const Root = styled.div``;

const Scores = styled.div`
  position: relative;
  border-bottom: 1px solid ${grayBorder};
`;

const VersionAndSuggestFixes = styled.div``;
